/**
 *  @name: private.jsx
 *  @version: 1.0.0
 *  @author: Trejocode - Sergio
 *  @description: Página privada
 */

import React from "react";
import Layout from "../layout";
import Sidebar from "../../components/header/sidebar";
import GeneralInventory from "../../components/inventory/generalInventory";

const Inventory = () => (
  <Layout
    title="Inventario General"
    description="Página privada de perfil"
    keywords="Reactjs, SEO Ready, Ejemplo"
  >
    <Sidebar />
    <GeneralInventory></GeneralInventory>
  </Layout>
);

export default Inventory;
